import { useEffect } from "react";

import Link from "next/link";

import { Anchor, AssignmentsSVG, Icon } from "@newsela/angelou";
import { useRouter } from "next/router";

import { useFetchNewStudentAssignments } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AssignmentsLink/hooks/useFetchNewStudentAssignments";
import {
  absoluteContainerCss,
  assignmentsIconCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AssignmentsLink/NewStudentAssignmentTooltip/NewStudentAssignmentTooltip.styles";
import { ASSIGNMENTS_MENU_ITEM_STUDENT } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { HOME_ROUTE } from "@/home/Home.constants";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

export const NEW_STUDENT_ASSIGNMENT_TOOLTIP = "new-student-assignments-tooltip";

const NewStudentAssignmentTooltip = () => {
  const { pathname } = useRouter();
  const isHomePage = (pathname || "").includes(HOME_ROUTE);

  const { isStudent } = useGetUserProperties();

  const [fetchNewStudentAssignments, { data: newStudentAssignments }] =
    useFetchNewStudentAssignments();

  useEffect(() => {
    isStudent && isHomePage && fetchNewStudentAssignments();
  }, []);

  if (!newStudentAssignments?.length) return null;

  const tooltipText = `${newStudentAssignments.length} new assignment${newStudentAssignments.length > 1 ? "s" : ""}`;

  return (
    <Link href={ASSIGNMENTS_MENU_ITEM_STUDENT.href} passHref legacyBehavior>
      <Anchor
        ariaProps={{ "aria-label": "View new assignments" }}
        dataProps={{
          "data-testid": NEW_STUDENT_ASSIGNMENT_TOOLTIP,
          "data-qa-selector": NEW_STUDENT_ASSIGNMENT_TOOLTIP,
        }}
      >
        <div css={absoluteContainerCss}>
          <Icon __cssFor={assignmentsIconCss} SvgComponent={AssignmentsSVG} />
          {tooltipText}
        </div>
      </Anchor>
    </Link>
  );
};

NewStudentAssignmentTooltip.displayName = "NewStudentAssignmentTooltip";
export { NewStudentAssignmentTooltip };
